import { api } from "../lib/axios";

export const getChargingStationInformation = async (stationId: string) => {
  const response = await api.get(`/charging-station/${stationId}`);
  return response.data;
};

export const startCharging = async (stationId: string) => {
  const response = await api.put(`/charge/${stationId}/start/`);
  return response.data;
};

export const stopCharging = async (stationId: string) => {
  const response = await api.put(`/charge/${stationId}/stop/`);
  return response.data;
};
